import { render } from "./InformationFontIcon.vue?vue&type=template&id=25ab7572&scoped=true&ts=true"
import script from "./InformationFontIcon.vue?vue&type=script&lang=ts"
export * from "./InformationFontIcon.vue?vue&type=script&lang=ts"

import "./InformationFontIcon.vue?vue&type=style&index=0&id=25ab7572&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ab7572"]])

export default __exports__